const yup = require('yup')
const { labelify } = require('./helpers')

const shape = labelify({
  profile: yup.mixed(),
  code: yup.string().nullable(),
  expiresAt: yup.date().nullable(),
  revoked: yup.boolean().default(false),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const mobileUserDeviceAssociationSchema = yup.object().shape(shape)

module.exports = { mobileUserDeviceAssociationSchema }
